import _typeof from "@babel/runtime/helpers/typeof";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { format, isAfter, isDate, parse } from 'date-fns';
import { isUndefined } from 'lodash-es';
import { START_DATE, END_DATE } from '@datepicker-react/hooks';
import { safeInvoke, isDefined, keys, ControlAppearanceType, ControlShapeType, Intent } from '../../../../library';
import { IconCalendar } from '../../../../icons';
import { Popover } from '../../../popover';
import { DatePicker } from '../../../date-picker';
import { Button } from '../../../button';
import { Input, inputClasses } from '../../text-input';
import { Control, Controls } from '../../control';
var dateInputClasses = {
  MAIN: 'date-input'
};
export var DateInput = function DateInput(props) {
  var _React$useState = React.useState(START_DATE),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusedInput = _React$useState2[0],
    setFocusedInput = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOpen = _React$useState4[0],
    setIsOpen = _React$useState4[1];
  var _React$useState5 = React.useState(),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    startInput = _React$useState6[0],
    setStartInput = _React$useState6[1];
  var _React$useState7 = React.useState(),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    endInput = _React$useState8[0],
    setEndInput = _React$useState8[1];
  var _React$useState9 = React.useState({
      start: null,
      end: null
    }),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    pickerDates = _React$useState10[0],
    setPickerDates = _React$useState10[1];
  var startInputRef = React.useRef(null);
  var endInputRef = React.useRef(null);
  React.useEffect(function () {
    var _startInputRef$curren;
    if (!isOpen && props.isRange && isDate(props.startDate) && ((_startInputRef$curren = startInputRef.current) === null || _startInputRef$curren === void 0 ? void 0 : _startInputRef$curren.querySelector('input')) === document.activeElement) {
      var _endInputRef$current;
      (_endInputRef$current = endInputRef.current) === null || _endInputRef$current === void 0 || (_endInputRef$current = _endInputRef$current.querySelector('input')) === null || _endInputRef$current === void 0 || _endInputRef$current.focus();
    }
  }, [props.startDate]);
  var convertInputToDate = function convertInputToDate(value) {
    var converted = parse(value, props.format, new Date());
    var isValid = !isNaN(converted.getTime());
    return isValid ? converted : null;
  };
  var handleDateChange = function handleDateChange(data) {
    if (!props.isRange) {
      safeInvoke(props.onUpdate, props.field, {
        startDate: data.startDate,
        endDate: data.endDate
      });
      setIsOpen(false);
    } else {
      if (data.focusedInput === null) {
        setIsOpen(false);
        setPickerDates({
          start: data.startDate,
          end: data.endDate
        });
        safeInvoke(props.onUpdate, props.field, {
          startDate: data.startDate,
          endDate: data.endDate
        });
      } else {
        var _props$endDate;
        safeInvoke(props.onUpdate, props.field, {
          startDate: data.startDate,
          endDate: (_props$endDate = props.endDate) !== null && _props$endDate !== void 0 ? _props$endDate : null
        });
        setFocusedInput(data.focusedInput);
        setPickerDates({
          start: data.startDate,
          end: null
        });
      }
    }
  };
  var handleManualInput = function handleManualInput() {
    if (isUndefined(startInput) && isUndefined(endInput)) return;
    var startDate = !isUndefined(startInput) ? convertInputToDate(startInput) : props.startDate;
    var endDate = !isUndefined(endInput) ? convertInputToDate(endInput) : props.endDate;
    setStartInput(undefined);
    setEndInput(undefined);
    if (startDate && endDate && isAfter(startDate, endDate)) {
      endDate = null;
    }
    ;
    safeInvoke(props.onUpdate, props.field, {
      startDate: startDate !== null && startDate !== void 0 ? startDate : null,
      endDate: endDate
    });
  };
  var handleInputBlur = function handleInputBlur(e) {
    handleManualInput();
    safeInvoke(props.onBlur, e);
  };
  var handleInputUpdate = function handleInputUpdate(field, value) {
    if (field === "".concat(props.field, "-start")) {
      setStartInput(value);
    }
    if (field === "".concat(props.field, "-end")) {
      setEndInput(value);
    }
  };
  var handleInputKeyDown = function handleInputKeyDown(e) {
    switch (e.which) {
      case keys.ARROW_DOWN:
        setIsOpen(true);
        break;
      case keys.ENTER:
        handleManualInput();
        break;
    }
  };
  var handleStartFocus = function handleStartFocus() {
    setFocusedInput(START_DATE);
  };
  var handleEndFocus = function handleEndFocus(e) {
    e.preventDefault();
    if (!isDefined(props.startDate)) {
      var _startInputRef$curren2;
      (_startInputRef$curren2 = startInputRef.current) === null || _startInputRef$curren2 === void 0 || (_startInputRef$curren2 = _startInputRef$curren2.querySelector('input')) === null || _startInputRef$curren2 === void 0 || _startInputRef$curren2.focus();
    } else {
      setFocusedInput(END_DATE);
    }
  };
  var handleStartClear = function handleStartClear() {
    safeInvoke(props.onUpdate, props.field, {
      startDate: null,
      endDate: null
    });
    safeInvoke(props.onClear);
  };
  var handleEndClear = function handleEndClear() {
    var _props$startDate;
    safeInvoke(props.onUpdate, props.field, {
      startDate: (_props$startDate = props.startDate) !== null && _props$startDate !== void 0 ? _props$startDate : null,
      endDate: null
    });
  };
  var handleDropdownToggle = function handleDropdownToggle(nextState) {
    setIsOpen(nextState);
    if (nextState === true) {
      var _props$startDate2, _props$endDate2;
      setPickerDates({
        start: (_props$startDate2 = props.startDate) !== null && _props$startDate2 !== void 0 ? _props$startDate2 : null,
        end: (_props$endDate2 = props.endDate) !== null && _props$endDate2 !== void 0 ? _props$endDate2 : null
      });
      if (!props.endDate && props.startDate) {
        setFocusedInput(END_DATE);
      } else {
        setFocusedInput(START_DATE);
      }
    } else {
      if (props.isRange && isDefined(pickerDates.start) && !isDefined(pickerDates.end)) {
        setPickerDates(_objectSpread(_objectSpread({}, pickerDates), {}, {
          end: pickerDates.start
        }));
        safeInvoke(props.onUpdate, props.field, {
          startDate: pickerDates.start,
          endDate: pickerDates.start
        });
      }
    }
  };
  var renderDropdownButton = function renderDropdownButton() {
    return React.createElement(Popover, {
      isOpen: isOpen,
      autoFocus: true,
      content: renderDatePicker(),
      position: "bottom",
      isDisabled: props.isDisabled,
      onVisibilityChange: handleDropdownToggle
    }, React.createElement(Button, {
      density: props.density,
      appearance: props.appearance,
      shape: props.shape,
      size: props.size,
      intent: props.intent,
      label: React.createElement(IconCalendar, {
        size: props.size
      }),
      isDisabled: props.isDisabled
    }));
  };
  var renderDatePicker = function renderDatePicker() {
    return React.createElement(DatePicker, {
      focusedInput: focusedInput,
      startDate: pickerDates.start,
      endDate: pickerDates.end,
      onDatesChange: handleDateChange,
      isRange: props.isRange
    });
  };
  var placeholders = typeof props.placeholder === 'string' ? {
    start: props.placeholder
  } : props.placeholder;
  var inputProps = {
    appearance: props.appearance,
    density: props.density,
    intent: props.intent,
    isDisabled: props.isDisabled,
    isClearable: props.isClearable,
    shape: props.shape,
    size: props.size,
    readOnly: props.isReadOnly
  };
  var containerClasses = cn(dateInputClasses.MAIN, {
    '-range': props.isRange
  }, props.className);
  var formattedDates = {
    start: isDefined(props.startDate) ? format(props.startDate, props.format) : '',
    end: isDefined(props.endDate) ? format(props.endDate, props.format) : ''
  };
  return React.createElement("div", {
    className: containerClasses,
    style: props.style
  }, React.createElement(Controls, {
    isCombined: true
  }, React.createElement(Control, null, React.createElement(Input, _extends({
    field: "".concat(props.field, "-start"),
    className: inputClasses.INPUT,
    ref: startInputRef,
    value: startInput !== null && startInput !== void 0 ? startInput : formattedDates.start,
    placeholder: placeholders.start,
    onUpdate: handleInputUpdate,
    onClear: handleStartClear,
    onFocus: handleStartFocus,
    onKeyDown: handleInputKeyDown,
    onBlur: handleInputBlur
  }, inputProps))), props.isRange ? React.createElement(Control, null, React.createElement(Input, _extends({
    field: "".concat(props.field, "-end"),
    className: inputClasses.INPUT,
    ref: endInputRef,
    value: endInput !== null && endInput !== void 0 ? endInput : formattedDates.end,
    placeholder: _typeof(props.placeholder) === 'object' ? props.placeholder.end : '',
    onFocus: handleEndFocus,
    onClear: handleEndClear,
    onKeyDown: handleInputKeyDown,
    onUpdate: handleInputUpdate,
    onBlur: handleInputBlur
  }, inputProps))) : null, !props.isReadOnly && React.createElement(Control, {
    span: "shrink"
  }, renderDropdownButton())));
};
DateInput.defaultProps = {
  appearance: ControlAppearanceType.OUTLINE,
  endDate: null,
  format: 'MM/dd/yyyy',
  intent: Intent.NONE,
  placeholder: {
    start: 'Start Date',
    end: 'End Date'
  },
  shape: ControlShapeType.ROUNDED,
  startDate: null
};